/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Coupon code
 */
export interface IncustControllersTermApiTerminalCouponByCodeRequest {
  /**
   * Coupon code
   */
  code?: string;
  /**
   * Coupon external code
   */
  external_code?: string;
}
